import Grid from '@mui/material/Grid';

import { SecretsTable } from 'components/sections';

export const SecretsSharedByMe = () => {
  return (
    <Grid container spacing={0.5} item xs={12} direction="column">
      <Grid item>
        <SecretsTable sharedWithMe={false} />
      </Grid>
    </Grid>
  );
};

export default SecretsSharedByMe;
